import React, { useCallback, useState } from 'react';

import styled from 'styled-components';

import { APIEntityType } from '@cd3p/core/types/api';
import { SENSITIVE_FIELD_PLACEHOLDER } from '@cd3p/core/utils/sensitiveData';
import { Tooltip, Typography } from 'components';

import { RequestAccessModal } from './RequestAccessModal';

import { TOOLTIP_APPEAR_DELAY } from 'constants/common';

const Wrapper = styled(Typography)<{ $clickable?: boolean }>`
  color: ${props => props.theme.custom.palette.gray};
  text-decoration: none;
  line-height: 1.25;
  font-size: 1.4rem;
  filter: blur(3px);
  padding: 0 0.4rem;
  cursor: ${props => (props.$clickable ? 'pointer' : 'default')};
`;

type Props = {
  className?: string;
  showTooltip?: boolean;
  text?: string;
  entityType?: APIEntityType;
  entityId?: string | number;
  onClick?: () => void;
};

export const SensitiveData: React.FC<Props> = React.forwardRef(
  (
    {
      className,
      showTooltip = true,
      text = SENSITIVE_FIELD_PLACEHOLDER,
      onClick,
      entityId,
      entityType,
    },
    ref,
  ) => {
    const [showRequestModal, setShowRequestModal] = useState(false);
    const handleClick = useCallback(
      (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.stopPropagation();
        if (!entityId || !entityType) {
          return;
        }
        if (onClick) {
          onClick();
        } else {
          setShowRequestModal(true);
        }
      },
      [entityId, entityType, onClick],
    );
    return (
      <>
        <Tooltip
          ref={ref}
          placement="top-start"
          enterDelay={TOOLTIP_APPEAR_DELAY}
          enterNextDelay={TOOLTIP_APPEAR_DELAY}
          title={showTooltip ? text : ''}
        >
          <Wrapper
            className={className}
            $clickable={Boolean(onClick || (entityId && entityType))}
            onClick={handleClick}
          >
            {text}
          </Wrapper>
        </Tooltip>
        {showRequestModal && (
          <RequestAccessModal
            onClose={() => setShowRequestModal(false)}
            requestedEntityId={entityId}
            requestedEntityType={entityType}
          />
        )}
      </>
    );
  },
);
